import {Link, useLocation, useNavigate, useParams} from "react-router-dom";
import React, {useContext, useEffect, useRef, useState} from "react";
import {object} from "prop-types";
import {useTranslation} from "react-i18next";
import Modal from 'react-bootstrap/Modal';

function StaticMeasureHelps({SewingModelId}) {
    const {t} = useTranslation();
    const location = useLocation();
    const [pageLanguage, setPageLanguage] = useState(location.pathname.split('').slice(1, 3).join(''));
    const [helpMeasure, setHelpMeasure] = useState(SewingModelId === "0099" ? "hasRod" : "Inside");
    const [helpMeasureLengthType, setHelpMeasureLengthType] = useState("Sill");
    
    
    return (
        <>
            {SewingModelId === "0303" &&
                <>
                    <p className="measurementsHelp_modal_title">{t("HOW TO MEASURE FOR ZEBRA SHADES")}</p>
                    <div className="help_options_container">
                        <ul className="help_options">
                            <li className={`help_option_item ${helpMeasure === "Inside" ? "help_option_item_on" : ""}`}
                                onClick={() => setHelpMeasure("Inside")}>{t("bold_Inside_mount")}</li>
                            <li className="help_option_item_separator"></li>
                            <li className={`help_option_item ${helpMeasure === "Outside" ? "help_option_item_on" : ""}`}
                                onClick={() => setHelpMeasure("Outside")}>{t("bold_Outside_mount")}</li>
                            <li className="help_option_item_separator"></li>
                            <li className={`help_option_item ${helpMeasure === "HiddenMoulding" ? "help_option_item_on" : ""}`}
                                onClick={() => setHelpMeasure("HiddenMoulding")}>{t("bold_Arc_mount")}</li>
                        </ul>
                    </div>
                    {helpMeasure === "Inside" &&
                        <div>
                            <div className="measurementsHelp_modal_img_section">
                                {/*<p className="measurementsHelp_modal_img_title">{t("Inside Mount")}</p>*/}
                                <object className="measurementsHelp_modal_img" type="image/svg+xml"
                                        data={pageLanguage === 'fa' ? require('../Images/drapery/zebra/new_step3_help_inside.svg').default : require('../Images/drapery/zebra/new_step3_help_inside.svg').default}/>
                            </div>
                            <div className="accordion_help measurementsHelp_modal_help_section">
                                <div className="help_container">
                                    <div className="help_column help_left_column">
                                        <p className="help_column_header">{t("TO DETERMINE INSIDE MOUNT")}</p>
                                        <ul className="help_column_list">
                                            <li>{t("modal_help_1")}</li>
                                            <li>{t("modal_help_2")}</li>
                                            <li>{t("modal_help_2.5")}</li>
                                            <li>{t("modal_help_3")}</li>
                                        </ul>
                                    </div>
                                    
                                    <div className="help_column help_left_column">
                                        <p className="help_column_header">{t("STEP 1: MEASURE WIDTH")}</p>
                                        <ul className="help_column_list">
                                            <li>{t("modal_help_4")}</li>
                                            <li>{t("modal_help_5")}</li>
                                        </ul>
                                    </div>
                                    
                                    <div className="help_column help_right_column">
                                        <p className="help_column_header">{t("STEP 2: MEASURE LENGTH")}</p>
                                        <ul className="help_column_list">
                                            <li>{t("modal_help_6")}</li>
                                            <li>{t("modal_help_7")}</li>
                                        </ul>
                                    </div>
                                </div>
                                <br/>
                                <br/>
                                <div className="help_container">
                                    <div className="help_column help_right_column">
                                        <p className="help_column_header"/>
                                        <ul className="help_column_list">
                                            <li><b>{t("Note:&nbsp;")}</b>{t("modal_help_8")}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    {/*<br/>*/}
                    {/*<br/>*/}
                    {/*<br/>*/}
                    
                    {helpMeasure === "Outside" &&
                        <div>
                            <div className="measurementsHelp_modal_img_section">
                                {/*<p className="measurementsHelp_modal_title">{t("HOW TO MEASURE FOR ZEBRA SHADES")}</p>*/}
                                {/*<p className="measurementsHelp_modal_img_title">{t("Outside Mount")}</p>*/}
                                <object className="measurementsHelp_modal_img" type="image/svg+xml"
                                        data={pageLanguage === 'fa' ? require('../Images/drapery/zebra/new_step3_help_outside_fa.svg').default : require('../Images/drapery/zebra/new_step3_help_outside.svg').default}/>
                            </div>
                            <div className="accordion_help measurementsHelp_modal_help_section">
                                <div className="help_container">
                                    <div className="help_column help_left_column">
                                        <p className="help_column_header">{t("TO DETERMINE OUTSIDE MOUNT")}</p>
                                        <ul className="help_column_list">
                                            <li>{t("modal_help_9")}</li>
                                            <li>{t("modal_help_10")}</li>
                                            <li>{t("modal_help_11")}</li>
                                        </ul>
                                    </div>
                                    
                                    <div className="help_column help_left_column">
                                        <p className="help_column_header">{t("STEP 1: MEASURE WIDTH")}</p>
                                        <ul className="help_column_list">
                                            <li>{t("modal_help_12")}</li>
                                            <li>{t("modal_help_13")}</li>
                                        </ul>
                                    </div>
                                    
                                    <div className="help_column help_right_column">
                                        <p className="help_column_header">{t("STEP 2: MEASURE LENGTH")}</p>
                                        <ul className="help_column_list">
                                            <li>{t("modal_help_14")}</li>
                                            <li>{t("modal_help_15")}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    {helpMeasure === "HiddenMoulding" &&
                        <div>
                            <div className="measurementsHelp_modal_img_section">
                                {/*<p className="measurementsHelp_modal_title">{t("HOW TO MEASURE FOR ZEBRA SHADES")}</p>*/}
                                {/*<p className="measurementsHelp_modal_img_title">{t("Outside Mount")}</p>*/}
                                <object className="measurementsHelp_modal_img" type="image/svg+xml"
                                        data={pageLanguage === 'fa' ? require('../Images/drapery/zebra/new_step3_help_arc_fa.svg').default : require('../Images/drapery/zebra/new_step3_help_arc.svg').default}/>
                            </div>
                            <div className="accordion_help measurementsHelp_modal_help_section">
                                <div className="help_container">
                                    <div className="help_column help_left_column">
                                        <p className="help_column_header">{t("TO DETERMINE HIDDEN MOULDING MOUNT")}</p>
                                        <ul className="help_column_list">
                                            <li>{t("modal_help_16")}</li>
                                            <li>{t("modal_help_17")}</li>
                                            <li>{t("modal_help_18")}</li>
                                        </ul>
                                    </div>
                                    
                                    <div className="help_column help_left_column">
                                        <p className="help_column_header">{t("STEP 1: MEASURE WIDTH")}</p>
                                        <ul className="help_column_list">
                                            <li>{t("modal_help_19")}</li>
                                            <li>{t("modal_help_20")}</li>
                                        </ul>
                                    </div>
                                    
                                    <div className="help_column help_right_column">
                                        <p className="help_column_header">{t("STEP 2: MEASURE LENGTH")}</p>
                                        <ul className="help_column_list">
                                            <li>{t("modal_help_21")}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    <br/>
                </>
            }
            {SewingModelId === "0324" &&
                <>
                    <p className="measurementsHelp_modal_title">{t("HOW TO MEASURE FOR ROLLER SHADES")}</p>
                    <div className="help_options_container">
                        <ul className="help_options">
                            <li className={`help_option_item ${helpMeasure === "Inside" ? "help_option_item_on" : ""}`}
                                onClick={() => setHelpMeasure("Inside")}>{t("bold_Inside_mount")}</li>
                            <li className="help_option_item_separator"></li>
                            <li className={`help_option_item ${helpMeasure === "Outside" ? "help_option_item_on" : ""}`}
                                onClick={() => setHelpMeasure("Outside")}>{t("bold_Outside_mount")}</li>
                            <li className="help_option_item_separator"></li>
                            <li className={`help_option_item ${helpMeasure === "HiddenMoulding" ? "help_option_item_on" : ""}`}
                                onClick={() => setHelpMeasure("HiddenMoulding")}>{t("bold_Arc_mount")}</li>
                        </ul>
                    </div>
                    {helpMeasure === "Inside" &&
                        <div>
                            <div className="measurementsHelp_modal_img_section">
                                <object className="measurementsHelp_modal_img" type="image/svg+xml"
                                        data={pageLanguage === 'fa' ? require('../Images/drapery/zebra/new_step3_help_inside.svg').default : require('../Images/drapery/zebra/new_step3_help_inside.svg').default}/>
                            </div>
                            <div className="accordion_help measurementsHelp_modal_help_section">
                                <div className="help_container">
                                    <div className="help_column help_left_column">
                                        <p className="help_column_header">{t("TO DETERMINE INSIDE MOUNT")}</p>
                                        <ul className="help_column_list">
                                            <li>{t("modal_help_1")}</li>
                                            <li>{t("roller_modal_help_2")}</li>
                                            <li>{t("modal_help_2.5")}</li>
                                            <li>{t("modal_help_3")}</li>
                                        </ul>
                                    </div>
                                    
                                    <div className="help_column help_left_column">
                                        <p className="help_column_header">{t("STEP 1: MEASURE WIDTH")}</p>
                                        <ul className="help_column_list">
                                            <li>{t("roller_modal_help_4")}</li>
                                            <li>{t("roller_modal_help_5")}</li>
                                        </ul>
                                    </div>
                                    
                                    <div className="help_column help_right_column">
                                        <p className="help_column_header">{t("STEP 2: MEASURE LENGTH")}</p>
                                        <ul className="help_column_list">
                                            <li>{t("modal_help_6")}</li>
                                            <li>{t("roller_modal_help_7")}</li>
                                        </ul>
                                    </div>
                                </div>
                                <br/>
                                <br/>
                                <div className="help_container">
                                    <div className="help_column help_right_column">
                                        <p className="help_column_header"/>
                                        <ul className="help_column_list">
                                            <li><b>{t("Note:&nbsp;")}</b>{t("roller_modal_help_8")}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    
                    {/*<br/>*/}
                    {/*<br/>*/}
                    {/*<br/>*/}
                    
                    {helpMeasure === "Outside" &&
                        <div>
                            <div className="measurementsHelp_modal_img_section">
                                <object className="measurementsHelp_modal_img" type="image/svg+xml"
                                        data={pageLanguage === 'fa' ? require('../Images/drapery/zebra/new_step3_help_outside_fa.svg').default : require('../Images/drapery/zebra/new_step3_help_outside.svg').default}/>
                            </div>
                            <div className="accordion_help measurementsHelp_modal_help_section">
                                <div className="help_container">
                                    <div className="help_column help_left_column">
                                        <p className="help_column_header">{t("TO DETERMINE OUTSIDE MOUNT")}</p>
                                        <ul className="help_column_list">
                                            <li>{t("modal_help_9")}</li>
                                            <li>{t("roller_modal_help_10")}</li>
                                            <li>{t("modal_help_11")}</li>
                                        </ul>
                                    </div>
                                    
                                    <div className="help_column help_left_column">
                                        <p className="help_column_header">{t("STEP 1: MEASURE WIDTH")}</p>
                                        <ul className="help_column_list">
                                            <li>{t("roller_modal_help_12")}</li>
                                            <li>{t("roller_modal_help_13")}</li>
                                        </ul>
                                    </div>
                                    
                                    <div className="help_column help_right_column">
                                        <p className="help_column_header">{t("STEP 2: MEASURE LENGTH")}</p>
                                        <ul className="help_column_list">
                                            <li>{t("roller_modal_help_14")}</li>
                                            <li>{t("modal_help_15")}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    {helpMeasure === "HiddenMoulding" &&
                        <div>
                            <div className="measurementsHelp_modal_img_section">
                                {/*<p className="measurementsHelp_modal_title">{t("HOW TO MEASURE FOR ZEBRA SHADES")}</p>*/}
                                {/*<p className="measurementsHelp_modal_img_title">{t("Outside Mount")}</p>*/}
                                <object className="measurementsHelp_modal_img" type="image/svg+xml"
                                        data={pageLanguage === 'fa' ? require('../Images/drapery/zebra/new_step3_help_arc_fa.svg').default : require('../Images/drapery/zebra/new_step3_help_arc.svg').default}/>
                            </div>
                            <div className="accordion_help measurementsHelp_modal_help_section">
                                <div className="help_container">
                                    <div className="help_column help_left_column">
                                        <p className="help_column_header">{t("TO DETERMINE HIDDEN MOULDING MOUNT")}</p>
                                        <ul className="help_column_list">
                                            <li>{t("modal_help_16")}</li>
                                            <li>{t("roller_modal_help_17")}</li>
                                            <li>{t("modal_help_18")}</li>
                                        </ul>
                                    </div>
                                    
                                    <div className="help_column help_left_column">
                                        <p className="help_column_header">{t("STEP 1: MEASURE WIDTH")}</p>
                                        <ul className="help_column_list">
                                            <li>{t("modal_help_19")}</li>
                                            <li>{t("roller_modal_help_20")}</li>
                                        </ul>
                                    </div>
                                    
                                    <div className="help_column help_right_column">
                                        <p className="help_column_header">{t("STEP 2: MEASURE LENGTH")}</p>
                                        <ul className="help_column_list">
                                            <li>{t("modal_help_21")}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    <br/>
                </>
            }
            {SewingModelId === "0325" &&
                <>
                    <p className="measurementsHelp_modal_title">{t("HOW TO MEASURE FOR DUAL ROLLER SHADES")}</p>
                    <div className="help_options_container">
                        <ul className="help_options">
                            <li className={`help_option_item ${helpMeasure === "Inside" ? "help_option_item_on" : ""}`}
                                onClick={() => setHelpMeasure("Inside")}>{t("bold_Inside_mount")}</li>
                            <li className="help_option_item_separator"></li>
                            <li className={`help_option_item ${helpMeasure === "Outside" ? "help_option_item_on" : ""}`}
                                onClick={() => setHelpMeasure("Outside")}>{t("bold_Outside_mount")}</li>
                            <li className="help_option_item_separator"></li>
                            <li className={`help_option_item ${helpMeasure === "HiddenMoulding" ? "help_option_item_on" : ""}`}
                                onClick={() => setHelpMeasure("HiddenMoulding")}>{t("bold_Arc_mount")}</li>
                        </ul>
                    </div>
                    {helpMeasure === "Inside" &&
                        <div>
                            <div className="measurementsHelp_modal_img_section">
                                <object className="measurementsHelp_modal_img" type="image/svg+xml"
                                        data={pageLanguage === 'fa' ? require('../Images/drapery/zebra/new_step3_help_inside.svg').default : require('../Images/drapery/zebra/new_step3_help_inside.svg').default}/>
                            </div>
                            <div className="accordion_help measurementsHelp_modal_help_section">
                                <div className="help_container">
                                    <div className="help_column help_left_column">
                                        <p className="help_column_header">{t("TO DETERMINE INSIDE MOUNT")}</p>
                                        <ul className="help_column_list">
                                            <li>{t("modal_help_1")}</li>
                                            <li>{t("roller_modal_help_2")}</li>
                                            <li>{t("modal_help_2.5")}</li>
                                            <li>{t("modal_help_3")}</li>
                                        </ul>
                                    </div>
                                    
                                    <div className="help_column help_left_column">
                                        <p className="help_column_header">{t("STEP 1: MEASURE WIDTH")}</p>
                                        <ul className="help_column_list">
                                            <li>{t("roller_modal_help_4")}</li>
                                            <li>{t("roller_modal_help_5")}</li>
                                        </ul>
                                    </div>
                                    
                                    <div className="help_column help_right_column">
                                        <p className="help_column_header">{t("STEP 2: MEASURE LENGTH")}</p>
                                        <ul className="help_column_list">
                                            <li>{t("modal_help_6")}</li>
                                            <li>{t("roller_modal_help_7")}</li>
                                        </ul>
                                    </div>
                                </div>
                                <br/>
                                <br/>
                                <div className="help_container">
                                    <div className="help_column help_right_column">
                                        <p className="help_column_header"/>
                                        <ul className="help_column_list">
                                            <li><b>{t("Note:&nbsp;")}</b>{t("dualroller_modal_help_8")}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    
                    {/*<br/>*/}
                    {/*<br/>*/}
                    {/*<br/>*/}
                    
                    {helpMeasure === "Outside" &&
                        <div>
                            <div className="measurementsHelp_modal_img_section">
                                <object className="measurementsHelp_modal_img" type="image/svg+xml"
                                        data={pageLanguage === 'fa' ? require('../Images/drapery/zebra/new_step3_help_outside_fa.svg').default : require('../Images/drapery/zebra/new_step3_help_outside.svg').default}/>
                            </div>
                            <div className="accordion_help measurementsHelp_modal_help_section">
                                <div className="help_container">
                                    <div className="help_column help_left_column">
                                        <p className="help_column_header">{t("TO DETERMINE OUTSIDE MOUNT")}</p>
                                        <ul className="help_column_list">
                                            <li>{t("modal_help_9")}</li>
                                            <li>{t("modal_help_10")}</li>
                                            <li>{t("modal_help_11")}</li>
                                        </ul>
                                    </div>
                                    
                                    <div className="help_column help_left_column">
                                        <p className="help_column_header">{t("STEP 1: MEASURE WIDTH")}</p>
                                        <ul className="help_column_list">
                                            <li>{t("modal_help_12")}</li>
                                            <li>{t("modal_help_13")}</li>
                                        </ul>
                                    </div>
                                    
                                    <div className="help_column help_right_column">
                                        <p className="help_column_header">{t("STEP 2: MEASURE LENGTH")}</p>
                                        <ul className="help_column_list">
                                            <li>{t("modal_help_14")}</li>
                                            <li>{t("modal_help_15")}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    {helpMeasure === "HiddenMoulding" &&
                        <div>
                            <div className="measurementsHelp_modal_img_section">
                                {/*<p className="measurementsHelp_modal_title">{t("HOW TO MEASURE FOR ZEBRA SHADES")}</p>*/}
                                {/*<p className="measurementsHelp_modal_img_title">{t("Outside Mount")}</p>*/}
                                <object className="measurementsHelp_modal_img" type="image/svg+xml"
                                        data={pageLanguage === 'fa' ? require('../Images/drapery/zebra/new_step3_help_arc_fa.svg').default : require('../Images/drapery/zebra/new_step3_help_arc.svg').default}/>
                            </div>
                            <div className="accordion_help measurementsHelp_modal_help_section">
                                <div className="help_container">
                                    <div className="help_column help_left_column">
                                        <p className="help_column_header">{t("TO DETERMINE HIDDEN MOULDING MOUNT")}</p>
                                        <ul className="help_column_list">
                                            <li>{t("modal_help_16")}</li>
                                            <li>{t("roller_modal_help_17")}</li>
                                            <li>{t("modal_help_18")}</li>
                                        </ul>
                                    </div>
                                    
                                    <div className="help_column help_left_column">
                                        <p className="help_column_header">{t("STEP 1: MEASURE WIDTH")}</p>
                                        <ul className="help_column_list">
                                            <li>{t("modal_help_19")}</li>
                                            <li>{t("roller_modal_help_20")}</li>
                                        </ul>
                                    </div>
                                    
                                    <div className="help_column help_right_column">
                                        <p className="help_column_header">{t("STEP 2: MEASURE LENGTH")}</p>
                                        <ul className="help_column_list">
                                            <li>{t("modal_help_21")}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    <br/>
                </>
            }
            {SewingModelId === "0326" &&
                <>
                    <p className="measurementsHelp_modal_title">{t("HOW TO MEASURE FOR DK CURTAIN")}</p>
                    <div className="help_options_container">
                        <ul className="help_options">
                            <li className={`help_option_item ${helpMeasure === "Inside" ? "help_option_item_on" : ""}`}
                                onClick={() => setHelpMeasure("Inside")}>{t("bold_Inside_mount")}</li>
                            <li className="help_option_item_separator"></li>
                            <li className={`help_option_item ${helpMeasure === "Wall" ? "help_option_item_on" : ""}`}
                                onClick={() => setHelpMeasure("Wall")}>{t("bold_Wall_mount")}</li>
                            <li className="help_option_item_separator"></li>
                            <li className={`help_option_item ${helpMeasure === "Ceiling" ? "help_option_item_on" : ""}`}
                                onClick={() => setHelpMeasure("Ceiling")}>{t("bold_Ceiling_mount")}</li>
                            <li className="help_option_item_separator"></li>
                            <li className={`help_option_item ${helpMeasure === "HiddenMoulding" ? "help_option_item_on" : ""}`}
                                onClick={() => setHelpMeasure("HiddenMoulding")}>{t("bold_Arc_mount")}</li>
                        </ul>
                    </div>
                    {helpMeasure === "Inside" &&
                        <div>
                            <div className="measurementsHelp_modal_img_section dk_measurementsHelp_modal_img_section">
                                {/*<p className="measurementsHelp_modal_img_title">{t("Inside Mount")}</p>*/}
                                <span>
                                    <object className="measurementsHelp_modal_img" type="image/svg+xml"
                                            data={pageLanguage === 'fa' ? require('../Images/drapery/dk/help_new_width_inside_3_fa.svg').default : require('../Images/drapery/dk/help_new_width_inside_3.svg').default}/>
                                </span>
                                <span>
                                    <object className="measurementsHelp_modal_img" type="image/svg+xml"
                                            data={pageLanguage === 'fa' ? require('../Images/drapery/dk/help_new_height_inside_3_fa.svg').default : require('../Images/drapery/dk/help_new_height_inside_3.svg').default}/>
                                </span>
                            </div>
                            <div className="accordion_help measurementsHelp_modal_help_section">
                                <div className="help_container">
                                    <div className="help_column help_left_column">
                                        <p className="help_column_header">{t("STEP 1: MEASURE WIDTH")}</p>
                                        <ul className="help_column_list">
                                            <li>{t("dk_modal_help_4")}</li>
                                            <li>{t("dk_modal_help_5")}</li>
                                        </ul>
                                    </div>
                                    
                                    <div className="help_column help_right_column">
                                        <p className="help_column_header">{t("STEP 2: MEASURE LENGTH")}</p>
                                        <ul className="help_column_list">
                                            <li>{t("modal_help_6")}</li>
                                            <li>{t("dk_modal_help_7")}</li>
                                        </ul>
                                    </div>
                                </div>
                                <br/>
                                <br/>
                                <div className="help_container">
                                    <div className="help_column help_right_column">
                                        <p className="help_column_header"/>
                                        <ul className="help_column_list">
                                            <li><b>{t("Note:&nbsp;")}</b>{t("dk_modal_help_8")}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    {/*<br/>*/}
                    {/*<br/>*/}
                    {/*<br/>*/}
                    
                    {helpMeasure === "Wall" &&
                        <div>
                            <div className="measurementsHelp_modal_img_section dk_measurementsHelp_modal_img_section">
                                {/*<p className="measurementsHelp_modal_title">{t("HOW TO MEASURE FOR ZEBRA SHADES")}</p>*/}
                                {/*<p className="measurementsHelp_modal_img_title">{t("Outside Mount")}</p>*/}
                                <object className="measurementsHelp_modal_img help_img_margin_top" type="image/svg+xml"
                                        data={pageLanguage === 'fa' ? require('../Images/drapery/dk/new_dk_Help_wall_fa.svg').default : require('../Images/drapery/dk/new_dk_Help_wall.svg').default}/>
                            </div>
                            <div className="accordion_help measurementsHelp_modal_help_section">
                                <div className="help_container">
                                    <div className="help_column help_left_column">
                                        <p className="help_column_header">{t("TO DETERMINE PANEL HEIGHT")}</p>
                                        <ul className="help_column_list">
                                            <li><b>{t("Floor:&nbsp;")}</b>{t("dk_wall_modal_help_1")}</li>
                                            <li><b>{t("Sill/Apron:&nbsp;")}</b>{t("dk_wall_modal_help_2")}</li>
                                        </ul>
                                    </div>
                                    
                                    <div className="help_column help_right_column">
                                        <p className="help_column_header">{t("TO DETERMINE PANEL WIDTH")}</p>
                                        <ul className="help_column_list">
                                            <li>{t("dk_wall_modal_help_3")}</li>
                                        </ul>
                                    </div>
                                </div>
                                <br/>
                                <br/>
                                <div className="help_container">
                                    <div className="help_column help_right_column">
                                        <p className="help_column_header"/>
                                        <ul className="help_column_list">
                                            <li><b>{t("Note:&nbsp;")}</b>{t("dk_wall_modal_help_4")}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    
                    {helpMeasure === "Ceiling" &&
                        <div>
                            <br/>
                            <div className="help_options_container">
                                <ul className="help_options help_options_lengthType">
                                    <li className={`help_option_lengthType_item ${helpMeasureLengthType === "Floor" ? "help_option_lengthType_item_on" : ""}`}
                                        onClick={() => setHelpMeasureLengthType("Floor")}>{t("help_FLOOR")}</li>
                                    <li className={`help_option_lengthType_item ${helpMeasureLengthType === "Sill" ? "help_option_lengthType_item_on" : ""}`}
                                        onClick={() => setHelpMeasureLengthType("Sill")}>{t("help_SILL/APRON")}</li>
                                </ul>
                            </div>
                            <div className="measurementsHelp_modal_img_section dk_measurementsHelp_modal_img_section">
                                {/*<p className="measurementsHelp_modal_title">{t("HOW TO MEASURE FOR ZEBRA SHADES")}</p>*/}
                                {/*<p className="measurementsHelp_modal_img_title">{t("Outside Mount")}</p>*/}
                                {helpMeasureLengthType === "Sill" &&
                                    <span>
                                        <object className="measurementsHelp_modal_img" type="image/svg+xml"
                                                data={pageLanguage === 'fa' ? require('../Images/drapery/dk/help_new_ceiling_to_window_3_fa.svg').default : require('../Images/drapery/dk/help_new_ceiling_to_window_3.svg').default}/>
                                    </span>
                                }
                                {helpMeasureLengthType === "Floor" &&
                                    <span>
                                        <object className="measurementsHelp_modal_img" type="image/svg+xml"
                                                data={pageLanguage === 'fa' ? require('../Images/drapery/dk/help_new_ceiling_to_floor_3_fa.svg').default : require('../Images/drapery/dk/help_new_ceiling_to_floor_3.svg').default}/>
                                    </span>
                                }
                                <span>
                                    <object className="measurementsHelp_modal_img" type="image/svg+xml"
                                            data={pageLanguage === 'fa' ? require('../Images/drapery/dk/help_new_FrameSize.svg').default : require('../Images/drapery/dk/help_new_FrameSize.svg').default}/>
                                </span>
                            </div>
                            <div className="accordion_help measurementsHelp_modal_help_section">
                                <div className="help_container">
                                    <div className="help_column help_left_column">
                                        <p className="help_column_header">{t("TO DETERMINE PANEL HEIGHT")}</p>
                                        <ul className="help_column_list">
                                            {helpMeasureLengthType === "Floor" &&
                                                <li><b>{t("Floor:&nbsp;")}</b>{t("dk_ceiling_modal_help_1")}</li>
                                            }
                                            {helpMeasureLengthType === "Sill" &&
                                                <li><b>{t("Sill/Apron:&nbsp;")}</b>{t("dk_ceiling_modal_help_2")}</li>
                                            }
                                        </ul>
                                    </div>
                                    
                                    <div className="help_column help_right_column">
                                        <p className="help_column_header">{t("TO DETERMINE PANEL WIDTH")}</p>
                                        <ul className="help_column_list">
                                            <li>{t("dk_ceiling_modal_help_3")}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    {helpMeasure === "HiddenMoulding" &&
                        <div>
                            <br/>
                            <div className="help_options_container">
                                <ul className="help_options help_options_lengthType">
                                    <li className={`help_option_lengthType_item ${helpMeasureLengthType === "Floor" ? "help_option_lengthType_item_on" : ""}`}
                                        onClick={() => setHelpMeasureLengthType("Floor")}>{t("help_FLOOR")}</li>
                                    <li className={`help_option_lengthType_item ${helpMeasureLengthType === "Sill" ? "help_option_lengthType_item_on" : ""}`}
                                        onClick={() => setHelpMeasureLengthType("Sill")}>{t("help_SILL/APRON")}</li>
                                </ul>
                            </div>
                            <div className="measurementsHelp_modal_img_section dk_measurementsHelp_modal_img_section">
                                {/*<p className="measurementsHelp_modal_title">{t("HOW TO MEASURE FOR ZEBRA SHADES")}</p>*/}
                                {/*<p className="measurementsHelp_modal_img_title">{t("Outside Mount")}</p>*/}
                                {helpMeasureLengthType === "Sill" &&
                                    <span>
                                        <object className="measurementsHelp_modal_img" type="image/svg+xml"
                                                data={pageLanguage === 'fa' ? require('../Images/drapery/dk/help_new_ceiling_to_window_3_arc_fa.svg').default : require('../Images/drapery/dk/help_new_ceiling_to_window_3_arc.svg').default}/>
                                    </span>
                                }
                                {helpMeasureLengthType === "Floor" &&
                                    <span>
                                        <object className="measurementsHelp_modal_img" type="image/svg+xml"
                                                data={pageLanguage === 'fa' ? require('../Images/drapery/dk/help_new_ceiling_to_floor_3_arc_fa.svg').default : require('../Images/drapery/dk/help_new_ceiling_to_floor_3_arc.svg').default}/>
                                    </span>
                                }
                                <span>
                                    <object className="measurementsHelp_modal_img" type="image/svg+xml"
                                            data={pageLanguage === 'fa' ? require('../Images/drapery/dk/help_new_FrameSize.svg').default : require('../Images/drapery/dk/help_new_FrameSize.svg').default}/>
                                </span>
                            </div>
                            <div className="accordion_help measurementsHelp_modal_help_section">
                                <div className="help_container">
                                    <div className="help_column help_left_column">
                                        <p className="help_column_header">{t("TO DETERMINE PANEL HEIGHT")}</p>
                                        <ul className="help_column_list">
                                            {helpMeasureLengthType === "Floor" &&
                                                <li><b>{t("Floor:&nbsp;")}</b>{t("dk_arc_modal_help_1")}</li>
                                            }
                                            {helpMeasureLengthType === "Sill" &&
                                                <li><b>{t("Sill/Apron:&nbsp;")}</b>{t("dk_arc_modal_help_2")}</li>
                                            }
                                        </ul>
                                    </div>
                                    
                                    <div className="help_column help_right_column">
                                        <p className="help_column_header">{t("TO DETERMINE PANEL WIDTH")}</p>
                                        <ul className="help_column_list">
                                            <li>{t("dk_arc_modal_help_3")}</li>
                                        </ul>
                                    </div>
                                </div>
                                <br/>
                                <br/>
                                <div className="help_container">
                                    <div className="help_column help_right_column">
                                        <p className="help_column_header"/>
                                        <ul className="help_column_list">
                                            <li><b>{t("Note:&nbsp;")}</b>{t("dk_arc_modal_help_4")}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    <br/>
                </>
            }
            {SewingModelId === "0097" &&
                <>
                    <p className="measurementsHelp_modal_title">{t("HOW TO MEASURE FOR ROMAN SHADES")}</p>
                    <div className="help_options_container">
                        <ul className="help_options">
                            <li className={`help_option_item ${helpMeasure === "Inside" ? "help_option_item_on" : ""}`}
                                onClick={() => setHelpMeasure("Inside")}>{t("bold_Inside_mount")}</li>
                            <li className="help_option_item_separator"></li>
                            <li className={`help_option_item ${helpMeasure === "Outside" ? "help_option_item_on" : ""}`}
                                onClick={() => setHelpMeasure("Outside")}>{t("bold_Outside_mount")}</li>
                            <li className="help_option_item_separator"></li>
                            <li className={`help_option_item ${helpMeasure === "HiddenMoulding" ? "help_option_item_on" : ""}`}
                                onClick={() => setHelpMeasure("HiddenMoulding")}>{t("bold_Arc_mount")}</li>
                        </ul>
                    </div>
                    {helpMeasure === "Inside" &&
                        <div>
                            <div className="measurementsHelp_modal_img_section">
                                <object className="measurementsHelp_modal_img" type="image/svg+xml"
                                        data={pageLanguage === 'fa' ? require('../Images/drapery/zebra/new_step3_help_inside.svg').default : require('../Images/drapery/zebra/new_step3_help_inside.svg').default}/>
                            </div>
                            <div className="accordion_help measurementsHelp_modal_help_section">
                                <div className="help_container">
                                    <div className="help_column help_left_column">
                                        <p className="help_column_header">{t("TO DETERMINE INSIDE MOUNT")}</p>
                                        <ul className="help_column_list">
                                            <li>{t("modal_help_1")}</li>
                                            <li>{t("roman_modal_help_2")}</li>
                                            <li>{t("modal_help_2.5")}</li>
                                            <li>{t("modal_help_3")}</li>
                                        </ul>
                                    </div>
                                    
                                    <div className="help_column help_left_column">
                                        <p className="help_column_header">{t("STEP 1: MEASURE WIDTH")}</p>
                                        <ul className="help_column_list">
                                            <li>{t("roman_modal_help_4")}</li>
                                            <li>{t("roman_modal_help_5")}</li>
                                        </ul>
                                    </div>
                                    
                                    <div className="help_column help_right_column">
                                        <p className="help_column_header">{t("STEP 2: MEASURE LENGTH")}</p>
                                        <ul className="help_column_list">
                                            <li>{t("modal_help_6")}</li>
                                            <li>{t("roman_modal_help_7")}</li>
                                        </ul>
                                    </div>
                                </div>
                                <br/>
                                <br/>
                                <div className="help_container">
                                    <div className="help_column help_right_column">
                                        <p className="help_column_header"/>
                                        <ul className="help_column_list">
                                            <li><b>{t("Note:&nbsp;")}</b>{t("roman_modal_help_8")}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    
                    {/*<br/>*/}
                    {/*<br/>*/}
                    {/*<br/>*/}
                    
                    {helpMeasure === "Outside" &&
                        <div>
                            <div className="measurementsHelp_modal_img_section">
                                <object className="measurementsHelp_modal_img" type="image/svg+xml"
                                        data={pageLanguage === 'fa' ? require('../Images/drapery/zebra/new_step3_help_outside_fa.svg').default : require('../Images/drapery/zebra/new_step3_help_outside.svg').default}/>
                            </div>
                            <div className="accordion_help measurementsHelp_modal_help_section">
                                <div className="help_container">
                                    <div className="help_column help_left_column">
                                        <p className="help_column_header">{t("TO DETERMINE OUTSIDE MOUNT")}</p>
                                        <ul className="help_column_list">
                                            <li>{t("modal_help_9")}</li>
                                            <li>{t("roman_modal_help_10")}</li>
                                            <li>{t("modal_help_11")}</li>
                                        </ul>
                                    </div>
                                    
                                    <div className="help_column help_left_column">
                                        <p className="help_column_header">{t("STEP 1: MEASURE WIDTH")}</p>
                                        <ul className="help_column_list">
                                            <li>{t("roman_modal_help_12")}</li>
                                            <li>{t("roman_modal_help_13")}</li>
                                        </ul>
                                    </div>
                                    
                                    <div className="help_column help_right_column">
                                        <p className="help_column_header">{t("STEP 2: MEASURE LENGTH")}</p>
                                        <ul className="help_column_list">
                                            <li>{t("roman_modal_help_14")}</li>
                                            <li>{t("roman_modal_help_15")}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    {helpMeasure === "HiddenMoulding" &&
                        <div>
                            <div className="measurementsHelp_modal_img_section">
                                {/*<p className="measurementsHelp_modal_title">{t("HOW TO MEASURE FOR ZEBRA SHADES")}</p>*/}
                                {/*<p className="measurementsHelp_modal_img_title">{t("Outside Mount")}</p>*/}
                                <object className="measurementsHelp_modal_img" type="image/svg+xml"
                                        data={pageLanguage === 'fa' ? require('../Images/drapery/zebra/new_step3_help_arc_fa.svg').default : require('../Images/drapery/zebra/new_step3_help_arc.svg').default}/>
                            </div>
                            <div className="accordion_help measurementsHelp_modal_help_section">
                                <div className="help_container">
                                    <div className="help_column help_left_column">
                                        <p className="help_column_header">{t("TO DETERMINE HIDDEN MOULDING MOUNT")}</p>
                                        <ul className="help_column_list">
                                            <li>{t("modal_help_16")}</li>
                                            <li>{t("roman_modal_help_17")}</li>
                                            <li>{t("modal_help_18")}</li>
                                        </ul>
                                    </div>
                                    
                                    <div className="help_column help_left_column">
                                        <p className="help_column_header">{t("STEP 1: MEASURE WIDTH")}</p>
                                        <ul className="help_column_list">
                                            <li>{t("modal_help_19")}</li>
                                            <li>{t("roman_modal_help_20")}</li>
                                        </ul>
                                    </div>
                                    
                                    <div className="help_column help_right_column">
                                        <p className="help_column_header">{t("STEP 2: MEASURE LENGTH")}</p>
                                        <ul className="help_column_list">
                                            <li>{t("modal_help_21")}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    <br/>
                </>
            }
            {SewingModelId === "0099" &&
                <>
                    <p className="measurementsHelp_modal_title">{t("HOW TO MEASURE FOR GROMMET DRAPERY")}</p>
                    <div className="help_options_container">
                        <ul className="help_options">
                            <li className={`help_option_item ${helpMeasure === "hasRod" ? "help_option_item_on" : ""}`}
                                onClick={() => setHelpMeasure("hasRod")}>{t("bold_help_hasRod")}</li>
                            <li className="help_option_item_separator"></li>
                            <li className={`help_option_item ${helpMeasure === "noRod" ? "help_option_item_on" : ""}`}
                                onClick={() => setHelpMeasure("noRod")}>{t("bold_help_noRod")}</li>
                        </ul>
                    </div>
                    
                    <>
                        {helpMeasure === "hasRod" &&
                            <div>
                                <div className="measurementsHelp_modal_img_section">
                                    {/*<p className="measurementsHelp_modal_img_title">{t("Inside Mount")}</p>*/}
                                    <object className="measurementsHelp_modal_img" type="image/svg+xml"
                                            data={pageLanguage === 'fa' ? require('../Images/drapery/grommet/help_hasRod_fa.svg').default : require('../Images/drapery/grommet/help_hasRod.svg').default}/>
                                </div>
                                <div className="accordion_help measurementsHelp_modal_help_section">
                                    <div className="help_container">
                                        <div className="help_column help_left_column">
                                            <p className="help_column_header">{t("TO DETERMINE PANEL HEIGHT")}</p>
                                            <ul className="help_column_list">
                                                <li>{t("grommet_modal_help_1")}</li>
                                                <li className="help_or">{t("OR")}</li>
                                                <li>{t("grommet_modal_help_2")}</li>
                                            </ul>
                                        </div>
                                        
                                        <div className="help_column help_right_column">
                                            <p className="help_column_header">{t("TO DETERMINE PANEL WIDTH")}</p>
                                            <ul className="help_column_list">
                                                <li>{t("grommet_modal_help_3")}</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                        {/*<br/>*/}
                        {/*<br/>*/}
                        {/*<br/>*/}
                        
                        {helpMeasure === "noRod" && <div>
                            <div className="measurementsHelp_modal_img_section">
                                {/*<p className="measurementsHelp_modal_title">{t("HOW TO MEASURE FOR ZEBRA SHADES")}</p>*/}
                                {/*<p className="measurementsHelp_modal_img_title">{t("Outside Mount")}</p>*/}
                                <object className="measurementsHelp_modal_img" type="image/svg+xml"
                                        data={pageLanguage === 'fa' ? require('../Images/drapery/grommet/help_noRod_fa.svg').default : require('../Images/drapery/grommet/help_noRod.svg').default}/>
                            </div>
                            <div className="accordion_help measurementsHelp_modal_help_section">
                                <div className="help_container">
                                    <div className="help_column help_left_column">
                                        <p className="help_column_header">{t("TO DETERMINE PANEL HEIGHT")}</p>
                                        <ul className="help_column_list">
                                            <li>{t("grommet_modal_help_4")}</li>
                                            <li className="help_or">{t("OR")}</li>
                                            <li>{t("grommet_modal_help_5")}</li>
                                        </ul>
                                    </div>
                                    
                                    <div className="help_column help_right_column">
                                        <p className="help_column_header">{t("TO DETERMINE PANEL WIDTH")}</p>
                                        <ul className="help_column_list">
                                            <li>{t("grommet_modal_help_6")}</li>
                                            <li>{t("grommet_modal_help_wall_1")}</li>
                                            <li>{t("grommet_modal_help_wall_2")}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        }
                    </>
                    <br/>
                </>
            }
        </>
    );
}

export default StaticMeasureHelps;